import {
    FETCH_SHOPIFY_VARIANTS_REQUEST,
    FETCH_SHOPIFY_VARIANTS_SUCCESS,
    FETCH_SHOPIFY_VARIANTS_FAILURE,
    UPDATE_VARIANT_REQUEST,
    UPDATE_VARIANT_SUCCESS,
    UPDATE_VARIANT_FAILURE,
    BULK_UPDATE_VARIANTS_REQUEST,
    BULK_UPDATE_VARIANTS_SUCCESS,
    BULK_UPDATE_VARIANTS_FAILURE,
    SET_VARIANTS_FILTERS,
    SET_VARIANTS_PAGINATION
} from '../actions';

const initialState = {
    variants: [],
    isLoading: false,
    error: null,
    filters: {
        searchText: '',
        shopifyStoreId: 'all',
        shopifyProductId: 'all',
        hasSku: undefined,
        hasBusinessSku: undefined,
        inventoryStatus: 'all'
    },
    pagination: {
        current: 1,
        pageSize: 50,
        total: 0
    },
    isUpdating: false
};

const shopifyVariantsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHOPIFY_VARIANTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case FETCH_SHOPIFY_VARIANTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                variants: action.payload.variants,
                pagination: {
                    ...state.pagination,
                    ...action.payload.pagination
                }
            };

        case FETCH_SHOPIFY_VARIANTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        case SET_VARIANTS_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        case SET_VARIANTS_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        case UPDATE_VARIANT_REQUEST:
        case BULK_UPDATE_VARIANTS_REQUEST:
            return {
                ...state,
                isUpdating: true
            };

        case UPDATE_VARIANT_SUCCESS:
        case BULK_UPDATE_VARIANTS_SUCCESS:
            return {
                ...state,
                isUpdating: false
            };

        case UPDATE_VARIANT_FAILURE:
        case BULK_UPDATE_VARIANTS_FAILURE:
            return {
                ...state,
                isUpdating: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default shopifyVariantsReducer;
